// components/popUps/UserInfoModal/UserInfoModal.tsx

import type React from 'react'
import { useState } from 'react'
import ModalWindow from 'components/popUps/ModalWindow/ModalWindow'
import BaseInput from 'components/inputs/BaseInput/BaseInput'
import BaseSelect from 'components/inputs/BaseSelect/BaseSelect'
import Button from 'components/buttons/Button/Button'
import { saveSignupInfo } from 'api/AuthAPI'
import './UserInfoModal.scss'

const CONSTRUCTION_TRADES = [
  { id: '1', label: 'General Contractor' },
  { id: '2', label: 'Supplier' },
  { id: '3', label: 'Manufacturer' },
  { id: '4', label: 'Framing' },
  { id: '5', label: 'Concrete' },
  { id: '6', label: 'Masonry' },
  { id: '7', label: 'Drywall' },
  { id: '8', label: 'Roofing' },
  { id: '9', label: 'HVAC' },
  { id: '10', label: 'Electrical' },
  { id: '11', label: 'Plumbing' },
  { id: '12', label: 'Flooring' },
  { id: '13', label: 'Painting' },
  { id: '14', label: 'Demolition' },
  { id: '15', label: 'Excavation' },
  { id: '16', label: 'Landscaping' },
  { id: '17', label: 'Paving' },
  { id: '18', label: 'Siding' },
  { id: '19', label: 'Stucco' },
  //add developer builder and estimator
  { id: '21', label: 'Developer' },
  { id: '22', label: 'Builder' },
  { id: '23', label: 'Estimator' },
  { id: '24', label: 'Other' },
]

interface UserInfoModalProps {
  isOpened: boolean
  onClose: () => void
}

const UserInfoModal: React.FC<UserInfoModalProps> = ({ isOpened, onClose }) => {
  const [phone, setPhone] = useState('')
  const [trade, setTrade] = useState('')
  const [saving, setSaving] = useState(false)

  const formatPhoneNumber = (value: string): string => {
    const digits = value.replace(/\D/g, '').slice(0, 10)
    if (digits.length === 0) return ''
    if (digits.length <= 3) return `(${digits}`
    if (digits.length <= 6) return `(${digits.slice(0, 3)}) ${digits.slice(3)}`
    return `(${digits.slice(0, 3)}) ${digits.slice(3, 6)}-${digits.slice(6)}`
  }

  const handleSubmit = async () => {
    if (!phone.trim() && !trade.trim()) return

    setSaving(true)
    try {
      await saveSignupInfo({
        phone: phone.trim() || undefined,
        trade: trade.trim() || undefined,
      })
      onClose()
    } catch (err) {
      console.error('Failed to save user info:', err)
      onClose()
    } finally {
      setSaving(false)
    }
  }

  const handleClose = async () => {
    // await saveSignupInfo({
    //   phone: phone.trim() || undefined,
    //   trade: 'None',
    // })
    setPhone('')
    setTrade('')
    onClose()
  }

  if (!isOpened) return null

  return (
    <ModalWindow isOpened={isOpened} onCloseModal={handleClose} isCloseButton={true}>
      <div className="user-info-modal">
        <div className="user-info-modal__header">
          <h2 className="user-info-modal__title">Finish setting up your account</h2>
          <p className="user-info-modal__subtitle"> Just two more details so we can tailor TakeCost to your trade.</p>
        </div>

        <div className="user-info-modal__fields">
          <BaseInput
            label="Phone Number"
            type="tel"
            placeholder="(555) 555-5555"
            value={phone}
            onChange={(e) => setPhone(formatPhoneNumber(e.target.value))}
          />
          <BaseSelect
            label="What's your trade/occupation?"
            placeholder="Select or type your trade"
            options={CONSTRUCTION_TRADES}
            value={trade}
            onChange={(value) => setTrade(value)}
            onCreateNew={(value) => setTrade(value)}
            searchPlaceholder="Search or type your trade"
          />
        </div>

        <div className="user-info-modal__footer">
          <Button onClick={handleSubmit} width="100%" disabled={saving || (!phone.trim() && !trade.trim())}>
            {saving ? 'Saving...' : 'Continue'}
          </Button>
        </div>
      </div>
    </ModalWindow>
  )
}

export default UserInfoModal
